module.exports = __webpack_public_path__ + "img/imgSwim.9c4427fc.jpg";